import { getPpcList } from "./nova/ppc";
import type { Referral } from "../models/referral";

export interface GetReferralsParams {
  pageSize?: number;
  page?: number;
  location?: string;
  programType?: string;
}

export interface GetReferralsResult {
  data: Referral[];
  totalCount: number;
}

export async function getReferrals(
  params: GetReferralsParams = {},
): Promise<GetReferralsResult> {
  const { pageSize = 10, page = 1, location, programType } = params;

  const res = await getPpcList({
    isReferral: true,
    limit: pageSize,
    ...(location ? { location } : {}),
    ...(programType ? { programType } : {}),
  });

  return {
    data: res.data.map((ppc) => ({
      id: ppc.ppcId,
      ppcId: ppc.ppcId,
      programTypeId: ppc.programTypeId ?? null,
      caseNumber: ppc.participantId ?? "",
      primaryDrugOfChoice: ppc.primaryDrug ?? null,
      secondaryDrugOfChoice: ppc.secondaryDrug ?? null,
      tertiaryDrugOfChoice: ppc.tertiaryDrug ?? null,
      createdOn: ppc.createdOn,
      referredDate: ppc.referredByDate ?? ppc.referredByDateFormatted ?? null,
      status: ppc.ppcStatus,
      gender: ppc.gender,
      attorneyName: ppc.attorneyName ?? null,
      participant: {
        id: ppc.participantId ?? ppc.ppcId,
        firstName: ppc.firstName ?? "",
        lastName: ppc.lastName ?? "",
        preferredName: ppc.preferredName ?? null,
        admissionDate: ppc.admissionDateFormatted ?? null,
        dateOfBirth: ppc.dateOfBirth ?? null,
      },
    })),
    totalCount: res.count,
  };
}
